import {
  cameraProfileEquals,
  isCameraProfileComplete,
  normalizeCameraProfile,
} from '@/etc/cameraProfile'

export const MAX_CAMERA_PROFILE_PRESET_NAME_LENGTH = 40

export function createCameraProfilePresetId() {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return `camera-preset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
}

export function normalizeCameraProfilePresetName(value) {
  return `${value || ''}`
    .trim()
    .slice(0, MAX_CAMERA_PROFILE_PRESET_NAME_LENGTH)
}

export function normalizeCameraProfilePreset(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const id = `${value.id || ''}`.trim()
  const name = normalizeCameraProfilePresetName(value.name)
  const profile = normalizeCameraProfile(value.profile)
  if (!id || !name || !isCameraProfileComplete(profile)) return null
  const now = new Date().toISOString()
  return {
    id,
    name,
    profile,
    createdAt: `${value.createdAt || value.created_at || now}`.trim(),
    updatedAt: `${value.updatedAt || value.updated_at || now}`.trim(),
  }
}

export function normalizeAiCameraProfilePresets(value) {
  const list = Array.isArray(value) ? value : []
  const seen = new Set()
  return list
    .map(normalizeCameraProfilePreset)
    .filter((preset) => {
      if (!preset || seen.has(preset.id)) return false
      seen.add(preset.id)
      return true
    })
    .sort((left, right) =>
      `${right.updatedAt || ''}`.localeCompare(`${left.updatedAt || ''}`),
    )
}

export function cameraProfilePresetById(presets, id) {
  const wanted = `${id || ''}`.trim()
  if (!wanted) return null
  return (
    normalizeAiCameraProfilePresets(presets).find(
      (preset) => preset.id === wanted,
    ) || null
  )
}

export function cameraProfilePresetByName(presets, name) {
  const wanted = normalizeCameraProfilePresetName(name).toLowerCase()
  if (!wanted) return null
  return (
    normalizeAiCameraProfilePresets(presets).find(
      (preset) => preset.name.toLowerCase() === wanted,
    ) || null
  )
}

export function cameraProfileMatchesPreset(profile, preset) {
  const normalizedPreset = normalizeCameraProfilePreset(preset)
  return (
    !!normalizedPreset &&
    cameraProfileEquals(profile, normalizedPreset.profile)
  )
}
